import {useCallback, useState} from "react";
import {OrganShareDTO} from "../../../../types/organShare";
import {PageResponse, PageSearchCondition} from "../../../../types/page";
import {getSharedOrganListAsync} from "../../../../store/organShareSlice";
import {useAppDispatch} from "../../../../hooks/hooks";
import {useUtil} from "../../../../util/hooks/useUtil";
import {DEFAULT_PAGE_RESPONSE} from "../../../../util/etcUtil";

export function useSharedOrganGetter() {
    const {defaultErrorMessage} = useUtil();
    const dispatch = useAppDispatch();

    const [totalOrganCount, setTotalOrganCount] = useState<number | null>(null)
    const [sharedOrganList, setSharedOrganList] =
        useState<PageResponse<OrganShareDTO>>(DEFAULT_PAGE_RESPONSE)

    const getSharedOrganList = useCallback(
        async (param: PageSearchCondition) => {
            try {

                const result: PageResponse<OrganShareDTO> = await dispatch(getSharedOrganListAsync(param)).unwrap();
                setSharedOrganList(result)
                setTotalOrganCount(result.totalElements);

            } catch (e) {
                alert(defaultErrorMessage);
            }
        },
        //eslint-disable-next-line
        []
    );

    return{
        sharedOrganList, getSharedOrganList, totalOrganCount
    }
}